import { getInteractionsAggregates, GetInteractionsAggregatesParams } from '@/services/api';
import { useQuery } from 'react-query';

export const useGetInteractionsAggregates = (props: GetInteractionsAggregatesParams, enabled = true) => {
    const { dateRange, from, to, group_by, additional_group_bys, filters, variables, agent_ids, isPublic, shareId } = props;

    return useQuery({
        queryKey: [
            'interactions-aggregates',
            {
                dateRange,
                from: from.toISOString(),
                to: to.toISOString(),
                group_by,
                additional_group_bys,
                filters,
                variables,
                agent_ids,
                isPublic,
                shareId,
            },
        ],
        queryFn: () => getInteractionsAggregates(props),
        enabled,
        staleTime: 60 * 1000,
        cacheTime: 5 * 60 * 1000,
    });
};
